var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChairWheel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84047 5.32477C10.5916 5.32477 11.2005 4.69152 11.2005 3.91037C11.2005 3.12922 10.5916 2.49597 9.84047 2.49597C9.08936 2.49597 8.48047 3.12922 8.48047 3.91037C8.48047 4.69152 9.08936 5.32477 9.84047 5.32477Z",
    fill: "#848383"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8604 15.1424C12.6404 14.9136 12.2804 14.9136 12.0604 15.1424C12.0204 15.184 12.0004 15.2256 11.9604 15.2672C11.3004 16.3488 10.1204 17.056 8.80035 17.056C6.72035 17.056 5.06035 15.3088 5.06035 13.1664C5.06035 11.648 5.90035 10.3376 7.12035 9.69281C7.12035 9.69281 7.22035 9.63041 7.26035 9.58881C7.48035 9.36001 7.48035 8.98561 7.26035 8.77761C7.10035 8.61121 6.84035 8.56961 6.64035 8.65281L6.60035 8.67361C4.98035 9.50561 3.86035 11.232 3.86035 13.2496C3.86035 16.0576 6.06035 18.3456 8.76035 18.3456C10.5404 18.3456 12.0804 17.368 12.9404 15.912C13.0804 15.6416 13.0604 15.3504 12.8604 15.1424Z",
    fill: "#848383"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1998 15.0176L13.5598 12.2928C13.2798 12.0016 12.8998 11.8144 12.4798 11.8144H10.9198V9.25595H12.5598C12.8598 9.25595 13.0998 9.00635 13.0998 8.69435C13.0998 8.38235 12.8598 8.13275 12.5598 8.13275H10.9198V7.00955C10.9198 6.38555 10.4398 5.88635 9.83977 5.88635C9.23977 5.88635 8.75977 6.38555 8.75977 7.00955V8.71515C8.75977 8.71515 8.75977 12.48 8.75977 12.5424C8.75977 12.9376 9.05977 13.2496 9.43977 13.2496H12.5598L15.2398 16.016C15.4998 16.2864 15.9398 16.2864 16.1998 16.016C16.4598 15.7456 16.4598 15.288 16.1998 15.0176Z",
    fill: "#848383"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChairWheel);
export default __webpack_public_path__ + "static/media/chair-wheel.0ec732717edf7542f3d0fdb68138b1f7.svg";
export { ForwardRef as ReactComponent };